module.exports = __webpack_public_path__ + "img/logo.62888fb8.png";